import React, { useCallback, useMemo, useEffect, useState } from "react";
import { Tab, Row, Col, Nav, Card, ListGroup } from "react-bootstrap";
import parser from "html-react-parser";
import { Link } from "react-router-dom";

import "./Tabs.css";
import { useMetadata, usePresentationBySlug } from "hooks/query";
import { useSection } from "hooks/section";

export default function Tabs() {
    const setStoredTab = (key) => {
        localStorage.setItem("tabSelection", key);
    };

    const getStoredTab = localStorage.getItem("tabSelection") ?? "presentation";
    // let [socialmedias, setSocialmedias] = useState({});

    useEffect(() => {
        window.fbAsyncInit = () => {
            FB.init({
                appId: "138431822842527",
                autoLogAppEvents: true,
                xfbml: true,
                version: "v12.0",
            });
        };
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    }, []);
    return (
        <div className="mb-5">
            <Tab.Container defaultActiveKey={getStoredTab}>
                <Row className="serchAsideChildren">
                    <Tab.Content className="w-100">
                        <Tab.Pane eventKey="presentation">
                            <TabPresentation />
                        </Tab.Pane>
                    </Tab.Content>
                </Row>
            </Tab.Container>
        </div>
    );
}

function TabPresentation() {
    const { data } = usePresentationBySlug();

    return (
        <>
            <Row className="TabPresentation justify-evenly mt-5">
                <Col md={6} className="mr-5" id="content">
                    {data.content && parser(data.content)}
                </Col>
                <Col md={4} className="ml-5">
                    {data.socialmedias.$values && data.socialmedias.$values.length != 0 && (
                        <>
                            <h3>Facebook-feed</h3>
                            <div
                                class="fb-page"
                                data-href={
                                    data.socialmedias.$values.find((item) => item.socialmedia === "Facebook")?.fullUrl
                                }
                                data-width="500"
                                data-height="700"
                                data-hide-cover="false"
                                data-show-facepile="false"
                                data-adapt-container-width="true"
                                data-tabs="timeline"
                            ></div>
                        </>
                    )}
                    {data.video && (
                        <>
                            <h3 className="mt-5">Film</h3>
                            <div className="mb-5">{parser(data.video)}</div>
                        </>
                    )}
                </Col>
            </Row>

            <TabEducation />
        </>
    );
}

function TabEducation() {
    const presentationQuery = usePresentationBySlug();
    const metadataQuery = useMetadata();
    const { sectionUrl } = useSection();

    const getTagName = useCallback(
        (slug) => {
            return metadataQuery.data.tags.$values.find((item) => item.key === slug).value;
        },
        [metadataQuery]
    );

    const getSubjectName = useCallback(
        (slug) => {
            return metadataQuery.data.subjects.$values.find((item) => item.key === slug).value;
        },
        [metadataQuery]
    );

    const grouped = useMemo(
        () =>
            presentationQuery.data.adSubjectTags.$values.reduce((acc, curr) => {
                const { adSlug, subjectSlug, tagSlug, title } = curr;

                const onlyName = title.split(",")[0];
                const subjectName = getSubjectName(subjectSlug);
                const tagName = getTagName(tagSlug);

                if (acc[subjectName]) {
                    return {
                        ...acc,
                        [subjectName]: [...acc[subjectName], { adSlug, tagName, onlyName }],
                    };
                } else {
                    return {
                        ...acc,
                        [subjectName]: [{ adSlug, tagName, onlyName }],
                    };
                }
            }, {}),
        [presentationQuery, getSubjectName, getTagName]
    );

    return (
        <div className="TabEducation">
            <div className="bs-gutter-x card-columns">
                {Object.entries(grouped)
                    .sort(([a], [b]) => a.localeCompare(b))
                    .map(([subject, items]) => {
                        return (
                            <Card className="mb-1 ml-1 adList" key={subject}>
                                <Card.Header className="subject-weight">{subject}</Card.Header>
                                <ListGroup>
                                    {items
                                        .filter(function (item, pos) {
                                            return items.findIndex((i) => i.adSlug === item.adSlug) === pos;
                                        })
                                        .sort((a, b) => a.onlyName.localeCompare(b.onlyName))
                                        .map((item) => {
                                            return (
                                                <Link
                                                    key={item.adSlug}
                                                    to={{
                                                        pathname: `/${sectionUrl}/utbildning/${item.adSlug}`,
                                                        search: "",
                                                    }}
                                                >
                                                    <ListGroup.Item>{item.onlyName}</ListGroup.Item>
                                                </Link>
                                            );
                                        })}
                                </ListGroup>
                            </Card>
                        );
                    })}
            </div>
        </div>
    );
}

function TabContact() {
    const { data } = usePresentationBySlug();

    return (
        <Card className="TabContact">
            <Card.Body>
                <Row>
                    <Col xs={6} md={3}>
                        <h2>Telefon</h2>
                        <p>{data.phone ?? "Ingen telefon"}</p>
                    </Col>
                    <Col xs={6} md={3}>
                        <h2>Epost</h2>
                        <p>{data.email ?? "Ingen epost"}</p>
                    </Col>
                    <Col xs={6} md={3}>
                        <h2>Hemsida</h2>
                        {data.externalWebSite ? (
                            <a target="_blank" rel="noreferrer" href={data.externalWebSite}>
                                {data.externalWebSite}
                            </a>
                        ) : (
                            <p>Ingen hemsida</p>
                        )}
                    </Col>
                    <Col xs={6} md={3}>
                        <h2>Besöksadress</h2>
                        <p>{data.location ?? "Ingen besöksadress"}</p>
                    </Col>
                </Row>

                {data.socialmedias.$values.length > 0 && (
                    <Row className="mt-3">
                        {data.socialmedias.$values.map((item) => {
                            return (
                                <Col xs={6} md={3}>
                                    <h2>{item.socialmedia}</h2>
                                    <a target="_blank" rel="noreferrer" href={item.fullUrl}>
                                        Öppna
                                    </a>
                                </Col>
                            );
                        })}
                    </Row>
                )}
            </Card.Body>

            {/* <Row className="mt-3"> 
                <Col>
                    <iframe
                        title="Google maps"
                        width="100%"
                        height="300"
                        style={{ border: 0 }}
                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCmMnbT1jmwSL6zwj43ccWAtt-XivhYHJM&amp;q=Medborgarplatsen25+11872+Stockholm"
                        allowFullScreen
                    ></iframe>
                </Col>
            </Row> */}
        </Card>
    );
}
